module.exports = __webpack_public_path__ + "img/app_default_img2.fc66019f.png";